import uploadFile from 'src/components/BeaconV2Components/ExperimentalLayout/Finance/DisputeManagement/serverProxy/uploadFile';
import downloadFile from 'src/components/BeaconV2Components/ExperimentalLayout/Finance/DisputeManagement/serverProxy/downloadFile';
import deleteFile from 'src/components/BeaconV2Components/ExperimentalLayout/Finance/DisputeManagement/serverProxy/deleteFile';
import submitDisputes from 'src/components/BeaconV2Components/ExperimentalLayout/Finance/DisputeManagement/serverProxy/submitDisputes';

export { uploadFile, downloadFile, deleteFile, submitDisputes };
